<template>
    <div class="master-templates-sort-by">
        <div class="master-templates-sort-by__label">Sort by:</div>
        <Select :model-value="sortBy" @onChange="setValue">
            <Option v-for="option in options" :key="option.value" :label="option.label" :value="option.value">
                <span class="capitalize-text">{{ option.label }}</span>
                <Icon :type="arrowType(option.value)" class="data-sort__direction reporting__sortby-direction" />
            </Option>
        </Select>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { TemplatesSortBy, type TemplateSortByKey } from "@/enums/masterTemplate";
import { camelToUpperCase } from "@/utils";

export default defineComponent({
    name: "MasterTemplatesSortBy",

    emits: ["input"],

    data() {
        return {
            options: [] as { label: string; value: TemplateSortByKey }[],
            sortBy: "WIDTH_ASC" as TemplateSortByKey
        };
    },

    created() {
        this.options = Object.entries(TemplatesSortBy).map(([k, v]) => ({
            label: `${camelToUpperCase(v.field)}`,
            value: k as TemplateSortByKey
        }));

        const storageValue = window.localStorage.getItem("hox-master-sortby") as TemplateSortByKey | null;

        if (storageValue) {
            this.setValue(storageValue);
        }
    },

    methods: {
        arrowType(value: TemplateSortByKey) {
            const { dir } = TemplatesSortBy[value];
            return dir === "asc" ? "md-arrow-round-up" : "md-arrow-round-down";
        },

        setValue(val: TemplateSortByKey) {
            this.sortBy = val;
            window.localStorage.setItem("hox-master-sortby", val);
            this.$emit("input", TemplatesSortBy[val]);
        }
    }
});
</script>
<style lang="scss">
@use "@style/variables" as *;

.master-templates-sort-by {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 155px;
    flex: 0 0 155px;
    margin-right: $spacing;
}

.master-templates-sort-by__label {
    white-space: nowrap;
    display: flex;
    margin-right: $spacing-smaller;
}
</style>
